import { MediumIcon } from '@factorialco/deprecated-design-system'

import type { VariantsEnum } from './types'

export const DATO_PLAN_ICON_FIELD = 'iconId'
export const DATO_PLAN_ID_FIELD = 'internalTitle'
export const DATO_PLAN_TITLE_FIELD = 'title'
export const DATO_PLAN_DESCRIPTION_FIELD = 'description'
export const DATO_PLAN_SEG_OPTION_FIELD = 'segmentationOption'
export const BUSINESS_VARIANT = 'Business'
export const ENTERPRISE_VARIANT = 'Enterprise'
export const STARTER_PLAN_TYPE = 'starter'
export const PRO_PLAN_TYPE = 'pro'
export const MONTH_PERIOD = 'month'
export const YEAR_PERIOD = 'year'
export const MIN_SEATS = 10
export const DEFAULT_CURRENCY = 'EUR'
export const DEFAULT_ICON: MediumIcon = 'logo-avatar'

// Internal title will be "Operations Hub Enterprise", "Operations Hub Business",
// remove the last part to get the variant name
export function getVariantFromID(id: string): VariantsEnum {
  if (id.endsWith('Enterprise')) return ENTERPRISE_VARIANT
  return BUSINESS_VARIANT
}

export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)
